import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from 'scenes/Gallery/GalleryPage/schemas/screenSchema';

import { TAB_CONCEPTS, TAB_CONCEPT_FAMILIES, TAB_CREATIVES } from './constants';

export const gallerySearchParams = new SearchParams(screenSchema);

export const galleryLink = new Link('gallery', gallerySearchParams);

export const conceptPreviewLink = galleryLink.child(
  `${TAB_CONCEPTS}/:conceptId/preview`
);
export const conceptFamilyPreviewLink = galleryLink.child(
  `${TAB_CONCEPT_FAMILIES}/:conceptFamilyId/preview`
);

export const galleryLinkConceptsLink = galleryLink.child(`${TAB_CONCEPTS}`);
export const conceptDetailsLink = galleryLinkConceptsLink.child(':id');

export const creativeDetailsLink = galleryLink
  .child(`${TAB_CREATIVES}`)
  .child(':id');
